export default "__VITE_ASSET__fd406203__"